<style>
.ql-bubble .ql-tooltip {
  background-color: #444;
  position: fixed;
  border-radius: 25px;
  color: #fff;
  display: fix;
  z-index: 99999999 !important;
}

.ql-editor {
  overflow-y: hidden;
}

.signature-pad {
  border: 1px solid #ccc;
  background-image: linear-gradient(white, white),
    radial-gradient(circle at top left, #4bc5e8, #9f6274);
  background-origin: border-box;
  background-clip: content-box, border-box;
}

.signature-component {
  text-align: left;
  display: inline-block;
  width: 100%;
  max-width: 100%;
  border: 1x solid #ccc;
  h1 {
    margin-bottom: 0;
  }
  h2 {
    margin: 0;
    font-size: 100%;
  }
  button {
    padding: 1em;
    background: transparent;
    box-shadow: 2px 2px 4px #777;
    margin-top: 0.5em;
    border: 1px solid #777;
    font-size: 1rem;
    &.toggle {
      background: rgba(red, 0.2);
    }
  }
  canvas {
    display: block;
    position: absolute;
    border: 1px solid;
  }
  img {
    position: absolute;
    left: 0;
    top: 0;
  }
}
</style>

<template>
  <div>
          <v-snackbar
        v-model="snackbar"
        :timeout="10000"
        top="top"
        vertical="vertical"
      >
        {{ snackbarText }}
        <v-btn color="pink" flat @click="snackbar = false"> Close </v-btn>
      </v-snackbar>
    <v-container fluid v-if="validated" style="padding-top: 40px"> 
      <v-layout row wrap>
        <!-- <v-flex xs12>
          <v-btn
            color="purple darken-1"
            dark
            @click="
              dialog = true;
              initiateSignature();
            "
            >Click To Sign Document</v-btn
          >
        </v-flex> -->

        <v-flex
          xs12
          style="
            overflow: auto;
            -webkit-overflow-scrolling: touch !important;
            height: 1000px;
            overflow: none;
          "
        >
          <v-tabs centered color="white" icons-and-text>
            <v-tabs-slider color="purple"></v-tabs-slider>

            <v-tab
              :href="'#tab-' + index"
              v-for="(contentDetail, index) in contentDetails"
              :key="contentDetail.id"
            >
              {{ contentDetail.name ? contentDetail.name : "Unnamed Document" }}
              <!-- <v-icon>phone</v-icon> -->
            </v-tab>
            <v-tab-item
              v-for="(contentDetail, index) in contentDetails"
              :key="index"
              :value="'tab-' + index"
            >
              <v-card
                flat
                v-if="loadingContent"
                style="text-align: center; padding: 150px 20px; height: 700px"
              >
                <v-progress-circular
                  :size="70"
                  :width="7"
                  color="purple"
                  indeterminate
                ></v-progress-circular>
              </v-card>
              <v-card flat v-else>
                <v-card-actions>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn dark color="purple" v-on="on" @click="print('signature-content')"
                      >Print</v-btn>
                    </template>
                    <span> Click to print contract </span>
                  </v-tooltip>

                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn flat color="purple" v-on="on" @click="initiateSignature()"
                      >Click Here To Sign</v-btn>
                    </template>
                    <span> Click here to sign contract </span>
                  </v-tooltip>
                  
                  
                </v-card-actions>

                <v-container>
                  <v-layout row wrap>
                    <v-card-text style="height: 1200px">
                      <iframe
                        id="signature-content"
                        :ref="'contentDetailIframe' + contentDetail.id"
                        style="
                          border: 0px solid #666ccc;
                          width: 100%;
                          height: 100%;
                        "
                        title=""
                        frameborder="1"
                        scrolling="auto"
                        :srcdoc="content ? content.content : ''"
                      ></iframe>
                    </v-card-text>
                    <!-- src="https://legalworkflow365-public.s3.eu-west-2.amazonaws.com/taybull-company-registeration/Taybull+Soft+Registeration.pdf"
         -->
                  </v-layout>
                </v-container>
              </v-card>
            </v-tab-item>
          </v-tabs>
          <!-- <pdf
  v-for="i in numPages"
  :key="i"
  :src="src"
  :page="i"
  style="display: inline-block; width: 50%"
  ></pdf> -->
          <!-- <embed src="https://legalworkflow365-public.s3.eu-west-2.amazonaws.com/taybull-company-registeration/Taybull+Soft+Registeration.pdf" width="100%" height="100%"></embed> -->
          <!-- <iframe
            style="border: 0px solid #666ccc; width: 100%; height: 100%"
            title="PDF in an i-Frame"
            src="https://legalworkflow365-public.s3.eu-west-2.amazonaws.com/taybull-company-registeration/Taybull+Soft+Registeration.pdf"
            frameborder="1"
            scrolling="auto"
          ></iframe> -->

          <!-- <iframe style="border:0px solid #666CCC; width:100%;height:100%" title="PDF in an i-Frame" src="http://docs.google.com/gview?url=https://legalworkflow365-public.s3.eu-west-2.amazonaws.com/taybull-company-registeration/Taybull+Soft+Registeration.pdf&embedded=true" frameborder="1" scrolling="auto" ></iframe> -->
        </v-flex>
      </v-layout>

      <v-dialog
        v-model="dialog"
        persistent
        max-width="600px"
        ref="signatureContainer"
      >
        <!-- 
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark v-on="on">Open Dialog</v-btn>
          </template> 
      -->

        <v-card>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap v-if="content && content.content">
                <v-flex xs12 sm12 class="signature-component">
                  <span class="caption">Sign in the box below</span>
                  <div style="border: 1px solid #ccc" ref="signatureBox">
                    <canvas
                      id="signature-pad"
                      ref="signaturePad1"
                      height="200"
                    ></canvas>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
            <small>*indicates required field</small>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="dialog = false"
              >Close</v-btn
            >
            <v-btn color="red darken-1" flat @click="clear()">Start Over</v-btn>
            <v-btn
              color="purple darken-1"
              dark
              @click="save()"
              :loading="savingSignature"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
    <v-container fluid fill-height v-else>

      <v-layout align-center justify-center row wrap>
        <v-flex
          xs12
          sm8
          md4
          align-center
          justify-center
          style="
            text-align: center;
            background: #fff;
            padding: 10px;
            margin-top: 60px;
          "
        >
          <v-card class="elevation-12">
            <v-card-text>
              <img
                src="https://legalworkflow365-public.s3.eu-west-2.amazonaws.com/tlp-logo.png"
              />
              <p>Enter code below</p>
              <v-text-field
                label="Enter Code *"
                v-model="code"
                required
              ></v-text-field>
              <v-btn color="blue darken-1" flat @click="authorise()"
                >Click To Authorise</v-btn
              >
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- <v-dialog v-model="dialog" max-width="950px" height="800px">
 <v-btn color="primary" dark slot="activator">Open Dialog</v-btn>
  <v-card style="width:100%; height: 800px">
   <iframe style="width:100%; height: 100%" src="https://vuetifyjs.com"></iframe>
  </v-card>
 </v-dialog> -->
  </div>
</template>

<script>
import {
  getSignatureContent,
  createContent,
} from "@/models/freedomain";

import SignaturePad from "@/lib/signature-pad";

import ApiService from "@/services/api.service";

const atValues = [
  { id: 1, value: "Company Name" },
  { id: 2, value: "Company Address" },
  { id: 3, value: "Shareholder's Names" },
  { id: 4, value: "Shareholder's Deatils" },
  { id: 5, value: "Director's Names" },
  { id: 6, value: "Director's Details" },
  { id: 7, value: "Registeration Date" },
];
const hashValues = [];

let table = "test_lw_signatures";
let freeDomain = createContent();
let content = {
  name: "",
  description: "",
  html: "",
};

// console.log(freeDomain);
freeDomain.content = Object.assign({ ...content }, freeDomain.content);
freeDomain.hydrateForApi();

export default {
  props: ["chart"],
  data: function () {
    return {
      validated: false,
      urlCode: null,
      dialog: false,
      code: null,
      loading: false,
      snackbar: false,
      snackbarText: "",
      signature: null,
      signatureCode: null,
      savingSignature: false,
      contentDetails: [],
      content: { content: "<html><body><b>Bold</b></body></html>" },
      loadingContent: false,
      //  src: pdf.createLoadingTask('https://legalworkflow365-public.s3.eu-west-2.amazonaws.com/taybull-company-registeration/Taybull+Soft+Registeration.pdf'),
      numPages: undefined,
      form: {
        name: "",
        address: "",
        signature: "",
        identityDocument: "",
      },
      signaturePad: null,
      options: {
        penColor: "#000",
      },
      freeDomain: null,
      content: freeDomain.content.html,
      editorOption: {
        // theme: 'bubble',
        theme: "snow",
        modules: {
          mention: {
            allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
            mentionDenotationChars: ["@", "#"],
            source: function (searchTerm, renderList, mentionChar) {
              let values;

              if (mentionChar === "@") {
                values = atValues;
              } else {
                values = hashValues;
              }

              if (searchTerm.length === 0) {
                renderList(values, searchTerm);
              } else {
                const matches = [];
                for (let i = 0; i < values.length; i++)
                  if (
                    ~values[i].value
                      .toLowerCase()
                      .indexOf(searchTerm.toLowerCase())
                  )
                    matches.push(values[i]);
                renderList(matches, searchTerm);
              }
            },
          },
          toolbar: [
            [
              {
                size: ["small", false, "large"],
              },
            ],
            ["bold", "italic"],
            ["bold", "italic", "underline", "strike"], // toggled buttons
            ["blockquote", "code-block"],

            [
              {
                header: 1,
              },
              {
                header: 2,
              },
            ], // custom button values
            [
              {
                list: "ordered",
              },
              {
                list: "bullet",
              },
            ],
            [
              {
                script: "sub",
              },
              {
                script: "super",
              },
            ], // superscript/subscript
            [
              {
                indent: "-1",
              },
              {
                indent: "+1",
              },
            ], // outdent/indent
            [
              {
                direction: "rtl",
              },
            ], // text direction

            [
              {
                size: ["small", false, "large", "huge"],
              },
            ], // custom dropdown
            [
              {
                header: [1, 2, 3, 4, 5, 6, false],
              },
            ],

            [
              {
                color: [],
              },
              {
                background: [],
              },
            ], // dropdown with defaults from theme
            [
              {
                font: [],
              },
            ],
            [
              {
                align: [],
              },
            ],

            ["clean"],
            [
              {
                list: "ordered",
              },
              {
                list: "bullet",
              },
            ],
            ["link", "image"],
          ],
          history: {
            delay: 1000,
            maxStack: 50,
            userOnly: false,
          },
          imageDrop: true,
          //  imageResize: {
          //    displayStyles: {
          //      backgroundColor: 'black',
          //      border: 'none',
          //      color: 'white'
          //    },
          // //   modules: [ 'Resize', 'DisplaySize', 'Toolbar' ]
          //    modules: [ 'DisplaySize', 'Toolbar' ]
          //  }
        },
      },
    };
  },
  components: {
    //pdf,
    //'vue-signature-pad': VueSignature
  },
  methods: {
    print(id) {
      document.getElementById(id).contentWindow.print();
      // window.frames[id].focus();
      // window.frames[id].print();
    },
    clear() {
      this.signaturePad.clear();
    },
    async save() {
      // this.snackbarText =
      //   "Thank you " + this.freeDomain.name + ". You can now close this window";
      // this.snackbar = true;

      let payload = { urlCode: this.urlCode, passCode: this.code };
      payload.signature = this.signaturePad.toDataURL();
      this.savingSignature = true;

      try {
        let response = await ApiService.post("/p/signature", payload);
        let data = response.data;
        this.signature = data;
        this.snackbarText = "Thank you. Your signature have been sent for approval. Once approved, it will show in the contract. You can now close the window."
        this.snackbar = true;
      } catch (err) {}
      this.savingSignature = false;
      this.dialog = false;
      // this.validated = false;
      //
    },
    async authorise() {
      let progress = this.$Progress;

      if (!this.code) {
        this.snackbarText = "Enter a valid code";
        this.snackbar = true;
        return false;
      }

      progress.start();

      const payload = { urlCode: this.urlCode, passCode: this.code };
      console.log("payload", payload);
      try {
        let response = await ApiService.post("/p/signature/find", payload);

        const data = response.data;

        if (data.id) {
          this.signatureCode = data.code;
          this.signature = data;
          this.validated = true;
          this.loadContentDetails(data.code);

          ApiService.post("/p/signature/track", {
            model: "VIEWED_CONTRACT",
            modelId: data.id,
            message: data.fullname + "viewed contract",
            reference: data.email,
            type: "CONTRACT_EVENT",
          });
        }

        console.log("response", response);
      } catch (error) {
        this.snackbarText = "Invalid code";
        this.snackbar = true;
      }

      progress.finish();

      // if (this.code == this.freeDomain.openCode) {
      //   this.validated = true;
      //   this.code = "";
      // } else {
      //   this.code = "";
      //   this.snackbarText = "Invalid code";
      //   this.snackbar = true;
      // }
    },
    async loadContentDetails(signatureCode) {
      this.loadingContent = true;
      const progress = this.$Progress;
      progress.start();
      try {
        let response = await ApiService.query(
          "/p/signature/content/detail/" + signatureCode,
          {}
        );
        const data = response.data;
        if (data.length) {
          this.contentDetails = data;
          this.loadContent(data[0].id);
        }
      } catch (error) {
        this.snackbarText = "Error getting contract documents.";
        this.snackbar = true;
      }

      progress.finish();
    },
    async loadContent(id) {
      this.loadingContent = true;
      this.content = null;

      const progress = this.$Progress;
      progress.start();
      try {
        let response = await ApiService.query("/p/signature/content/" + id, {});
        const data = response.data;

        if (data.id) {
          this.content = data;
          // console.log("this.$refs", this.$refs);
          let iframe = this.$refs.contentDetailIframe + id;
          if (iframe) {
            // iframe.src = 'data:text/html,' + encodeURIComponent(data.content);
          }
        }
      } catch (error) {
        this.snackbarText = "Error getting contract documents.";
        this.snackbar = true;
      }

      this.loadingContent = false;

      progress.finish();
    },
    initiateSignature() {
      this.dialog = true;
      this.$refs.signaturePad1.width = this.$refs.signatureBox.clientWidth;
      // console.log("this.$refs.signaturePad1.width", this.$refs.signaturePad1.width);
      this.$refs.signaturePad1.width = 480;

      //this.src.then(pdf => {
      // this.numPages = pdf.numPages;
      // });

// 
      this.signaturePad = new SignaturePad(this.$refs.signaturePad1, {
        backgroundColor: "rgba(255, 255, 255, 1)",
        penColor: "#284283",
        velocityFilterWeight: 0.7,
        minWidth: 1.0,
        maxWidth: 2.5,
        throttle: 16, // max x milli seconds on event update, OBS! this introduces lag for event update
        minPointDistance: 3,
      });

      if (this.signature && this.signature.signature) {
        try {
          this.signaturePad.fromDataURL(this.signature.signature, {height: 200});
        } catch (error) {}
      }
      //

      // console.log("this.signaturePad", this.signaturePad);
    },
    onEditorBlur(quill) {
      console.log("editor blur!", quill);
    },
    onEditorFocus(quill) {
      console.log("editor focus!", quill);
      // quill.theme.tooltip.edit();
      quill.theme.tooltip.show();
      return false;
    },
    onEditorReady(quill) {
      //console.log('editor ready!', quill)
    },
    onEditorChange({ quill, html, text }) {
      //console.log('editor change!', quill, html, text)
      //  this.content = html
      //  this.chart.changed(this.chart.parameters.content);
      //  console.log(this.chart.parameters.content.value);
    },
    undo() {
      this.$refs.signaturePad.undoSignature();
    },
    _save() {
      // this.freeDomain.content.html = this.content;
      // upsertContent(table, this.freeDomain);
    },
    saveSignature() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();

      // alert("Open DevTools see the save data.");
      console.log(isEmpty);
      console.log(data);
    },
    change() {
      this.options = {
        penColor: "#00f",
      };
    },
    resume() {
      this.options = {
        penColor: "#c0f",
      };
    },
    async get(id) {
      this.freeDomain = await getSignatureContent(table, id);
      // this.freeDomain.content = Object.assign({...content
      // }, this.freeDomain.content);
      // this.content = this.freeDomain.content.html;
      console.log("this.freeDomain", this.freeDomain);
    },
  },
  computed: {},
  mounted: function () {
    let params = this.$route.params;
    let query = this.$route.query;

    //  let templateId = 5;
    let templateId = params.id;
    this.urlCode = templateId.replace('contract@', 'contract_'); // numbers in GMB replace @ with _

    // if (templateId) {
    //   this.get(templateId);
    // }
    // this.mSetProjectId(params.projectId);
    //  console.log('this is current quill instance object', this.myQuillEditor);
  },
  beforeDestroy() {},
};
</script>
